import React, { useCallback, useRef } from "react";
import "./FontComponent.css";
import { useDispatch, useSelector } from "react-redux";
import {
  LowerCase,
  UpperCase,
  SmallCaps,
  UnderLine,
  iconOne,
  iconTwo,
  None,
} from "../../../../../assets/icons/index";
import {
  updateFontStyleState,
  saveFontStyle,
} from "../../../../../Redux/actions/projectActions";
import {
  Radio,
  Dropdown,
  ColorPicker,
  Number_point_Input,
  NumberInput_fontsize,
  Dropdown_fontFamily,
  RadioFont,
  NumberInput_pointFont,
} from "../../../../../Components";
import debounce from "lodash.debounce";
import { useEffect } from "react";
import { useState } from "react";
import Dropdown_fontFamilyto from "../../../../../Components/Dropdown/Dropdown_FontFamilyto";

//  font family is Archivo Narrow
const fontweightArchivo = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const laPetiteGazette = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontWeightColunaRounded = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold N/A", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

//font family is Barlow Condensed, Barlow Semi Condensed, noto sans, Raleway
// Saira Condensed, Kanit, montserrat
const fontweightAll = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

//  font family is Roboto Condensed
const fontweightNotMediumandSemiboldandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold N/A", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

//  font family is Source Sans Pro,
const fontweightNotMediumandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

//  font family is Roboto Condensed, Roboto
const fontweightNotSemoboldandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

// font family is Libre Baskerville
const fontweightShowRegularandExtrabold = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

//  font family is Tiillium Webt, Archivo Narrow
// cooper hewitt, Clear Sans, Oswald, Roboto Condensed, Source Sans Pro, Teko, Roboto
const fontweightNotExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotBlack = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotLight = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightOnlyRegularAndBold = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightOnlyFutura = [
  { label: "Light", value: 300 },
  { label: "Regular  N/A", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightOnlyTradeGothic = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const initialOptions = [
  { label : "Archivo Narrow", value: "archivo narrow" },
  { label : "Barlow Condensed", value: "barlow condensed" },
  { label : "Barlow Semi Condensed", value: "barlow semi condensed" },
  { label : "Clear Sans", value: "clear sans" },
  { label : "Coluna Rounded", value:"Coluna Rounded"},
  { label : "Cooper Hewitt", value: "cooper hewitt" },
  { label : "Courier Pitch", value: "Courier pitch" },
  { label : "Futura", value: "futura" },
  { label : "Kanit", value: "kanit" },
  { label : "Karla", value: "karla" },
  { label : "La Petite Gazette", value: "la petite gazette" },
  { label : "Libre Baskerville", value: "libre baskerville" },
  { label : "Marion", value: "marion"},
  { label : "Montserrat", value: "montserrat" },
  { label : "Noto Sans", value: "noto sans" },
  { label : "Oswald", value: "oswald" },
  { label : "Poppins", value: "poppins" },
  { label : "Playfair Display", value: "playfair display" },
  { label : "Raleway", value: "raleway" },
  { label : "Roboto", value: "roboto" },
  { label : "Roboto Condensed", value: "roboto condensed" },
  { label : "Saira Condensed", value: "saira condensed" },
  { label : "Source Sans Pro", value: "source sans pro" },
  { label : "Space Mono", value: "space mono" },
  { label : "Teko", value: "teko" },
  { label : "Tiillium Webt", value: "tiillium webt" },
  { label : "Trade Gothic", value: "trade gothic"},
  { label : "Trade Gothic Condensed", value : "Trade Gothic Condensed"},
];

const debounceTimeoutIds = {};

const FontComponent = ({label, type, currentOpen, setOpen, currentBlockType, isCard}) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([...initialOptions]);
  const [selectedID, setSelectedID] = useState("");
  const [selectedfontWeightID, setSelectedfontWeightID] = useState("");
  const [optionsForFont, setOptionsForFont] = useState([]);

  let fontStyleType = type;

  if (currentBlockType === "nameonly" && type === "name") {
    fontStyleType = "nameOnlyStyle";
  } else {
    fontStyleType = type;
  }

  let fontStyle = useSelector(
    (state) => state?.project?.fontStyle[fontStyleType]
  );

  React.useEffect(() => {
    const idx = options.findIndex((opt) => opt.value === fontStyle?.fontFamily);
    if (idx !== -1) {
      setSelectedID(idx);
    }
    const id = optionsForFont.findIndex(
      (opt) => opt.value === fontStyle?.fontWeight
    );
    if (id !== -1) {
      setSelectedfontWeightID(id);
    }
  }, [fontStyle, selectedID]);
  let Style = useSelector((state) => state?.project?.fontStyle?.role);
  const saveFonts = (key, value) => {
    dispatch(saveFontStyle(fontStyleType, currentBlockType, key, value, null, isCard));
  };

  const updateFontState = (key, value) => {
    dispatch(updateFontStyleState(type, key, value, currentBlockType));
  };

  const updateFontStateDebounced = debounce(updateFontState, 500);

  const handleFontHeaderClick = () => {
    if (currentOpen === type) {
      setOpen(null);
    } else {
      setOpen(type);
    }
  };

  // const debouncedSave = (key, value) => {
  //   if (debounceTimeoutIds[key]) {
  //     clearTimeout(debounceTimeoutIds[key]);
  //     debounceTimeoutIds[key] = null;
  //   }
  //   debounceTimeoutIds[key] = setTimeout(() => {
  //     saveFonts(key, value);
  //   }, 1000);
  // };

  // --- debounce timers per key (so "role:lineHeight" and "name:lineHeight" don't clash)
  const debounceTimeoutIds = useRef({});

  // --- debounced save function with optional targetType override
  const debouncedSave = useCallback(
    (key, value, targetType) => {
      const timerKey = targetType ? `${targetType}:${key}` : key;

      if (debounceTimeoutIds.current[timerKey]) {
        clearTimeout(debounceTimeoutIds.current[timerKey]);
        debounceTimeoutIds.current[timerKey] = null;
      }

      debounceTimeoutIds.current[timerKey] = setTimeout(() => {
        const saveType = targetType || fontStyleType;
        dispatch(
          saveFontStyle(saveType, currentBlockType, key, value, null, isCard)
        );
      }, 1000);
    },
    [dispatch, fontStyleType, currentBlockType, isCard]
  );


  // --- figure out which slice lineHeight belongs to
  const targetFontStyleType =
    currentBlockType === "rolename" && type === "name"
      ? "role"
      : fontStyleType;

  // --- value to show in the input
  const displayedLineHeight =
    targetFontStyleType === "role"
      ? Style?.lineHeight ?? fontStyle?.lineHeight ?? 1
      : fontStyle?.lineHeight ?? 1;

  const fontWieghtHandleSet = (fontFamily) => {
    if (fontFamily === "archivo narrow") {
      return fontweightArchivo;
    } else if (fontFamily === "la petite gazette") {
      return laPetiteGazette;
    } else if (
      fontFamily === "barlow condensed" ||
      fontFamily === "barlow semi condensed" ||
      fontFamily === "noto sans" ||
      fontFamily === "montserrat" ||
      fontFamily === "raleway" ||
      fontFamily === "saira condensed" ||
      fontFamily === "kanit" ||
      fontFamily === "poppins"
    ) {
      return fontweightAll;
    } else if (fontFamily === "roboto" || fontFamily === "clear sans") {
      return fontweightNotSemoboldandExtrabold;
    } else if (fontFamily === "roboto condensed") {
      return fontweightAll;
    } else if (fontFamily === "libre baskerville" || fontFamily === "marion" || fontFamily === "Trade Gothic Condensed") {
      return fontweightShowRegularandExtrabold;
    } else if (fontFamily === "source sans pro" || fontFamily === "tiillium webt") {
      return fontweightNotMediumandExtrabold;
    } else if (fontFamily === "cooper hewitt" || fontFamily === "teko" || fontFamily === "oswald") {
      return fontweightNotExtrabold;
    } else if (fontFamily === "karla") {
      return fontweightNotBlack;
    } else if (fontFamily === "playfair display") {
      return fontweightNotLight;
    } else if (fontFamily === "space mono") {
      return fontweightOnlyRegularAndBold;
    } else if (fontFamily === "Coluna Rounded" || fontFamily === "Courier pitch") {
      return fontWeightColunaRounded;
    } else if (fontFamily === "futura") {
      return fontweightOnlyFutura;
    } else if (fontFamily === "trade gothic") {
      return fontweightOnlyTradeGothic;
    }
  };

  useEffect(() => {
    setOptionsForFont(fontWieghtHandleSet(fontStyle?.fontFamily));
  }, [fontStyle?.fontFamily]);

  // const displayToast = (props) => {
  //   const formattedKeyName = props.keyName.replace(/([A-Z])/g, " $1");
  //   if (toastId?.current === null) {
  //     toastId.current = toast.success(
  //       <p>
  //         {" "}
  //         {formattedKeyName} {props.value}{" "}
  //       </p>,
  //       {
  //         autoClose: false,
  //         onClick: () => (toastId.current = null),
  //         closeButton: <p>X</p>,
  //       }
  //     );
  //   } else {
  //     toast.update(
  //       toastId.current,
  //       {
  //         render: (
  //           <p>
  //             {" "}
  //             {formattedKeyName} {props.value}{" "}
  //           </p>
  //         ),
  //         type: toast.TYPE.SUCCESS,
  //       },
  //       {
  //         autoClose: 500,
  //         onClick: () => (toastId.current = null),
  //         closeButton: <p>X</p>,
  //       }
  //     );
  //   }
  // };

  // useEffect(() => {
  //   let debouncer = setTimeout(() => {
  //     toast.dismiss(toastId?.current);
  //     toastId.current = null;
  //   }, 3000);
  //   return () => {
  //     clearTimeout(debouncer);
  //   };
  // }, [value]);

  // const notifyWithToast = async (value) => {
  //   setValue(value);
  //   displayToast(value);
  // };


  
  const isFontVisible = currentOpen === type;
  return (
    <div className={!isFontVisible ? "main-div" : "main-div bg-[#212226]"}>
      <div className={!isFontVisible ? "main-font" : "main-font margin-bottom"}>

        <div className={!isFontVisible ? "heading" : "active-heading"} onClick={handleFontHeaderClick}>

          <div className="fonts-lable">{label && <span className="font-lable">{label}</span>}</div>

          <div className={!isFontVisible ? "heading-data" : "active_heading-data"}>
            <p className="fontHeading w-[70%]">{fontStyle?.fontFamily}</p>
            <p className="w-[30%] font-family-manrope text-white font-extrabold fontHeading">{fontStyle?.fontSize} PX</p>
          </div>

          {/* <div className={!isFontVisible ? "heading-data" : "active_heading-data"}>
            <p className="w-[30%] font-family-manrope text-white font-extrabold fontHeading">{fontStyle?.fontSize} PX</p>
          </div> */}

          <div className="icon-fontBox">
            {currentOpen === type ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-chevron-up"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 15 12 9 18 15"></polyline>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-chevron-down"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            )}
          </div>

        </div>

        {!isFontVisible || (
          <div className="main-fontData ">
            
            <div className="main-section">
              {/* FontFamily */}
              <div className="section1">
              <span className="font-img" />
                <Dropdown_fontFamilyto
                  options={options}
                  value={fontStyle?.fontFamily ? fontStyle?.fontFamily : "archivo narrow"}
                  selectedID={selectedID}
                  onChange={(val) => {
                    updateFontState("fontFamily", val);
                    // debouncedSave("fontFamily", val);
                    // if (idx !== -1) {
                    //   const updatedOptions = [
                    //     options[idx],
                    //     ...options.slice(0, idx),
                    //     ...options.slice(idx + 1),
                    //   ];

                    //   setOptions(updatedOptions);
                    // }
                    saveFonts();
                  }}
                />
              </div>
              {/* Font Weight */}
              <div className="section2">
                <Dropdown_fontFamily
                  // options={(fontStyle?.fontFamily == "archivo narrow") ? fontweightNotLightandExtrabold : []}
                  // options={fontWieghtHandleSet(fontStyle?.fontFamily)}
                  options={optionsForFont}
                  // options={[]}
                  value={fontStyle?.fontWeight}
                  selectedID={selectedfontWeightID}
                  customWidth={{ minWidth: '7.5rem' }}
                  onChange={(val) => {
                    updateFontState("fontWeight", val);
                    // debouncedSave("fontWeight", val);
                    // if (idx !== -1) {
                    //   const updatedOptions = [
                    //     optionsForFont[idx],
                    //     ...optionsForFont.slice(0, idx),
                    //     ...optionsForFont.slice(idx + 1),
                    //   ];

                    //   setOptionsForFont(updatedOptions);
                    // }
                    saveFonts();
                  }}
                />
              </div>
            </div>

            <div className="main-section">
              {/* Font Size */}
              <div className="section1">
              <span className="font-img" />
                <NumberInput_fontsize
                  step="1"
                  min="8"
                  max="99"
                  value={fontStyle?.fontSize}
                  onChange={(val) => {
                    const num = Number(val);
                    updateFontState("fontSize", num);
                    const clamped = Math.min(Math.max(num, 8), 99);
                    debouncedSave("fontSize", clamped);
                  }}
                  postLabel="px"
                  inputBox
                />
              </div>
              {/* Radio - Text Transform */}
              <div className="section2">
                <RadioFont
                  options={[
                    { icon: None, value: "none" },
                    { icon: UpperCase, value: "uppercase" },
                    { icon: SmallCaps, value: "capitalize" },
                    { icon: LowerCase, value: "lowercase" },
                    { icon: UnderLine, value: "underline" },
                  ]}
                  value={fontStyle?.textTransform}
                  onChange={(val) => {
                    if (val === "underline") {
                      updateFontState("textDecoration", val);
                      // updateFontState("textTransform", "none");
                    } else {
                      updateFontState("textDecoration", "none");
                      updateFontState("textTransform", val);
                    }
                    saveFonts();
                  }}
                  withIcon
                />
              </div>
            </div>

            {/* Line Height */}
            <div className="main-section">
              <div className="section1">
                <img className="font-img" src={iconOne} alt="" />
                <NumberInput_pointFont
                  step="0.10"
                  min="0.80"
                  max="5.0"
                  comp="lineHeight"
                  value={
                    currentBlockType === "rolename" && type === "name"
                      ? Style?.lineHeight
                      : fontStyle?.lineHeight
                  }
                  onChange={(val) => {
                    const num = parseFloat(val);
                    if (isNaN(num)) return;
      
                    // clamp
                    const clamped = Math.min(Math.max(num, 0.8), 5.0);
      
                    if (targetFontStyleType === "role") {
                      // update role slice
                      dispatch(
                        updateFontStyleState("role", "lineHeight", clamped, currentBlockType)
                      );
                      debouncedSave("lineHeight", clamped, "role");
                    } else {
                      updateFontState("lineHeight", clamped);
                      debouncedSave("lineHeight", clamped);
                    }
                  }}
                />
              </div>
              <div className="section2">
                <div className="colorPicker-block">
                  <ColorPicker
                    value={fontStyle?.color}
                    onChange={(val) => { updateFontStateDebounced("color", val); }}
                    onBlur={saveFonts}
                  />
                </div>
              </div>
            </div>

            <div className="main-section">
              <div className="section1">
                <img className="font-img" src={iconTwo} alt="" />
                <NumberInput_pointFont        
                  step="0.1"
                  min="0.0"
                  max="4.9"
                  value={fontStyle?.letterSpacing}
                  onChange={(val) => {
                    updateFontState("letterSpacing", Number(val));
                    debouncedSave(
                      "letterSpacing",
                      parseFloat(val > -0.1 ? (val < 5.0 ? val : 0.0) : 4.9)
                    );
                  }}
                  inputBox
                />
              </div>

              {/* space bottom */}
              <div className="section2">
                {label === "Heading" || label === "Sub Heading" || label === "Song Title" ? (

                  <div className="text-section">
                    <span className="bg-gray" style={{ color: "#fff", fontSize: "18px", marginRight: "8px" }}>&darr;</span>
                    {/* <img className="font-img" src={iconTwo} /> */}
                    <NumberInput_fontsize
                      step="1"
                      min="0"
                      max="15"
                      value={fontStyle?.marginBottom ? fontStyle?.marginBottom : 0}
                      onChange={(val) => {
                        updateFontState("marginBottom", Number(val));
                        debouncedSave(
                          "marginBottom",
                          parseInt(val > 0 ? (val < 100 ? val : 0) : 99)
                        );
                      }}
                      inputBox
                    />
                  </div>
                ) : null}
              </div>
            </div>
          
          </div>
        )}
      </div>
    </div>
  );
};

export default FontComponent;